import React, { useState, useEffect, useCallback } from 'react';
import {
  Page,
  Layout,
  Card,
  DataTable,
  Text,
  BlockStack,
  InlineStack,
  Badge,
  Button,
  Modal,
  Box,
  Divider,
  EmptyState,
  Spinner,
  Select,
} from '@shopify/polaris';
import { api } from '../api';

/** Storefront links must open in a new tab (embedded admin blocks in-frame / same-tab navigation). */
function openStorefrontProductUrl(url) {
  if (!url || typeof url !== 'string') return;
  const w = window.open(url, '_blank');
  if (w) w.opener = null;
}

const COUNTRY_OPTIONS = [
  { label: 'All Countries', value: '' },
  { label: 'Afghanistan', value: 'Afghanistan' },
  { label: 'Albania', value: 'Albania' },
  { label: 'Algeria', value: 'Algeria' },
  { label: 'Andorra', value: 'Andorra' },
  { label: 'Angola', value: 'Angola' },
  { label: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
  { label: 'Argentina', value: 'Argentina' },
  { label: 'Armenia', value: 'Armenia' },
  { label: 'Australia', value: 'Australia' },
  { label: 'Austria', value: 'Austria' },
  { label: 'Azerbaijan', value: 'Azerbaijan' },
  { label: 'Bahamas', value: 'Bahamas' },
  { label: 'Bahrain', value: 'Bahrain' },
  { label: 'Bangladesh', value: 'Bangladesh' },
  { label: 'Barbados', value: 'Barbados' },
  { label: 'Belarus', value: 'Belarus' },
  { label: 'Belgium', value: 'Belgium' },
  { label: 'Belize', value: 'Belize' },
  { label: 'Benin', value: 'Benin' },
  { label: 'Bhutan', value: 'Bhutan' },
  { label: 'Bolivia', value: 'Bolivia' },
  { label: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
  { label: 'Botswana', value: 'Botswana' },
  { label: 'Brazil', value: 'Brazil' },
  { label: 'Brunei', value: 'Brunei' },
  { label: 'Bulgaria', value: 'Bulgaria' },
  { label: 'Burkina Faso', value: 'Burkina Faso' },
  { label: 'Burundi', value: 'Burundi' },
  { label: 'Cambodia', value: 'Cambodia' },
  { label: 'Cameroon', value: 'Cameroon' },
  { label: 'Canada', value: 'Canada' },
  { label: 'Cape Verde', value: 'Cape Verde' },
  { label: 'Central African Republic', value: 'Central African Republic' },
  { label: 'Chad', value: 'Chad' },
  { label: 'Chile', value: 'Chile' },
  { label: 'China', value: 'China' },
  { label: 'Colombia', value: 'Colombia' },
  { label: 'Comoros', value: 'Comoros' },
  { label: 'Congo', value: 'Congo' },
  { label: 'Costa Rica', value: 'Costa Rica' },
  { label: 'Croatia', value: 'Croatia' },
  { label: 'Cuba', value: 'Cuba' },
  { label: 'Cyprus', value: 'Cyprus' },
  { label: 'Czech Republic', value: 'Czech Republic' },
  { label: 'Denmark', value: 'Denmark' },
  { label: 'Djibouti', value: 'Djibouti' },
  { label: 'Dominica', value: 'Dominica' },
  { label: 'Dominican Republic', value: 'Dominican Republic' },
  { label: 'Ecuador', value: 'Ecuador' },
  { label: 'Egypt', value: 'Egypt' },
  { label: 'El Salvador', value: 'El Salvador' },
  { label: 'Equatorial Guinea', value: 'Equatorial Guinea' },
  { label: 'Eritrea', value: 'Eritrea' },
  { label: 'Estonia', value: 'Estonia' },
  { label: 'Ethiopia', value: 'Ethiopia' },
  { label: 'Fiji', value: 'Fiji' },
  { label: 'Finland', value: 'Finland' },
  { label: 'France', value: 'France' },
  { label: 'Gabon', value: 'Gabon' },
  { label: 'Gambia', value: 'Gambia' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Germany', value: 'Germany' },
  { label: 'Ghana', value: 'Ghana' },
  { label: 'Greece', value: 'Greece' },
  { label: 'Grenada', value: 'Grenada' },
  { label: 'Guatemala', value: 'Guatemala' },
  { label: 'Guinea', value: 'Guinea' },
  { label: 'Guinea-Bissau', value: 'Guinea-Bissau' },
  { label: 'Guyana', value: 'Guyana' },
  { label: 'Haiti', value: 'Haiti' },
  { label: 'Honduras', value: 'Honduras' },
  { label: 'Hungary', value: 'Hungary' },
  { label: 'Iceland', value: 'Iceland' },
  { label: 'India', value: 'India' },
  { label: 'Indonesia', value: 'Indonesia' },
  { label: 'Iran', value: 'Iran' },
  { label: 'Iraq', value: 'Iraq' },
  { label: 'Ireland', value: 'Ireland' },
  { label: 'Israel', value: 'Israel' },
  { label: 'Italy', value: 'Italy' },
  { label: 'Jamaica', value: 'Jamaica' },
  { label: 'Japan', value: 'Japan' },
  { label: 'Jordan', value: 'Jordan' },
  { label: 'Kazakhstan', value: 'Kazakhstan' },
  { label: 'Kenya', value: 'Kenya' },
  { label: 'Kiribati', value: 'Kiribati' },
  { label: 'Kuwait', value: 'Kuwait' },
  { label: 'Kyrgyzstan', value: 'Kyrgyzstan' },
  { label: 'Laos', value: 'Laos' },
  { label: 'Latvia', value: 'Latvia' },
  { label: 'Lebanon', value: 'Lebanon' },
  { label: 'Lesotho', value: 'Lesotho' },
  { label: 'Liberia', value: 'Liberia' },
  { label: 'Libya', value: 'Libya' },
  { label: 'Liechtenstein', value: 'Liechtenstein' },
  { label: 'Lithuania', value: 'Lithuania' },
  { label: 'Luxembourg', value: 'Luxembourg' },
  { label: 'Madagascar', value: 'Madagascar' },
  { label: 'Malawi', value: 'Malawi' },
  { label: 'Malaysia', value: 'Malaysia' },
  { label: 'Maldives', value: 'Maldives' },
  { label: 'Mali', value: 'Mali' },
  { label: 'Malta', value: 'Malta' },
  { label: 'Marshall Islands', value: 'Marshall Islands' },
  { label: 'Mauritania', value: 'Mauritania' },
  { label: 'Mauritius', value: 'Mauritius' },
  { label: 'Mexico', value: 'Mexico' },
  { label: 'Micronesia', value: 'Micronesia' },
  { label: 'Moldova', value: 'Moldova' },
  { label: 'Monaco', value: 'Monaco' },
  { label: 'Mongolia', value: 'Mongolia' },
  { label: 'Montenegro', value: 'Montenegro' },
  { label: 'Morocco', value: 'Morocco' },
  { label: 'Mozambique', value: 'Mozambique' },
  { label: 'Myanmar', value: 'Myanmar' },
  { label: 'Namibia', value: 'Namibia' },
  { label: 'Nauru', value: 'Nauru' },
  { label: 'Nepal', value: 'Nepal' },
  { label: 'Netherlands', value: 'Netherlands' },
  { label: 'New Zealand', value: 'New Zealand' },
  { label: 'Nicaragua', value: 'Nicaragua' },
  { label: 'Niger', value: 'Niger' },
  { label: 'Nigeria', value: 'Nigeria' },
  { label: 'North Korea', value: 'North Korea' },
  { label: 'North Macedonia', value: 'North Macedonia' },
  { label: 'Norway', value: 'Norway' },
  { label: 'Oman', value: 'Oman' },
  { label: 'Pakistan', value: 'Pakistan' },
  { label: 'Palau', value: 'Palau' },
  { label: 'Palestine', value: 'Palestine' },
  { label: 'Panama', value: 'Panama' },
  { label: 'Papua New Guinea', value: 'Papua New Guinea' },
  { label: 'Paraguay', value: 'Paraguay' },
  { label: 'Peru', value: 'Peru' },
  { label: 'Philippines', value: 'Philippines' },
  { label: 'Poland', value: 'Poland' },
  { label: 'Portugal', value: 'Portugal' },
  { label: 'Qatar', value: 'Qatar' },
  { label: 'Romania', value: 'Romania' },
  { label: 'Russia', value: 'Russia' },
  { label: 'Rwanda', value: 'Rwanda' },
  { label: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' },
  { label: 'Saint Lucia', value: 'Saint Lucia' },
  { label: 'Saint Vincent and the Grenadines', value: 'Saint Vincent and the Grenadines' },
  { label: 'Samoa', value: 'Samoa' },
  { label: 'San Marino', value: 'San Marino' },
  { label: 'Sao Tome and Principe', value: 'Sao Tome and Principe' },
  { label: 'Saudi Arabia', value: 'Saudi Arabia' },
  { label: 'Senegal', value: 'Senegal' },
  { label: 'Serbia', value: 'Serbia' },
  { label: 'Seychelles', value: 'Seychelles' },
  { label: 'Sierra Leone', value: 'Sierra Leone' },
  { label: 'Singapore', value: 'Singapore' },
  { label: 'Slovakia', value: 'Slovakia' },
  { label: 'Slovenia', value: 'Slovenia' },
  { label: 'Solomon Islands', value: 'Solomon Islands' },
  { label: 'Somalia', value: 'Somalia' },
  { label: 'South Africa', value: 'South Africa' },
  { label: 'South Korea', value: 'South Korea' },
  { label: 'South Sudan', value: 'South Sudan' },
  { label: 'Spain', value: 'Spain' },
  { label: 'Sri Lanka', value: 'Sri Lanka' },
  { label: 'Sudan', value: 'Sudan' },
  { label: 'Suriname', value: 'Suriname' },
  { label: 'Sweden', value: 'Sweden' },
  { label: 'Switzerland', value: 'Switzerland' },
  { label: 'Syria', value: 'Syria' },
  { label: 'Taiwan', value: 'Taiwan' },
  { label: 'Tajikistan', value: 'Tajikistan' },
  { label: 'Tanzania', value: 'Tanzania' },
  { label: 'Thailand', value: 'Thailand' },
  { label: 'Timor-Leste', value: 'Timor-Leste' },
  { label: 'Togo', value: 'Togo' },
  { label: 'Tonga', value: 'Tonga' },
  { label: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
  { label: 'Tunisia', value: 'Tunisia' },
  { label: 'Turkey', value: 'Turkey' },
  { label: 'Turkmenistan', value: 'Turkmenistan' },
  { label: 'Tuvalu', value: 'Tuvalu' },
  { label: 'Uganda', value: 'Uganda' },
  { label: 'Ukraine', value: 'Ukraine' },
  { label: 'United Arab Emirates', value: 'United Arab Emirates' },
  { label: 'United Kingdom', value: 'United Kingdom' },
  { label: 'United States', value: 'United States' },
  { label: 'Uruguay', value: 'Uruguay' },
  { label: 'Uzbekistan', value: 'Uzbekistan' },
  { label: 'Vanuatu', value: 'Vanuatu' },
  { label: 'Vatican City', value: 'Vatican City' },
  { label: 'Venezuela', value: 'Venezuela' },
  { label: 'Vietnam', value: 'Vietnam' },
  { label: 'Yemen', value: 'Yemen' },
  { label: 'Zambia', value: 'Zambia' },
  { label: 'Zimbabwe', value: 'Zimbabwe' },
];

const PER_PAGE_OPTIONS = [
  { label: '5 per page', value: '5' },
  { label: '10 per page', value: '10' },
  { label: '25 per page', value: '25' },
  { label: '50 per page', value: '50' },
];

const STATUS_TONE = {
  new: 'attention',
  reviewed: 'info',
  quoted: 'success',
  closed: 'subdued',
};

/**
 * Absolute or same-origin URL to the attachment binary.
 * Shopify embedded admin CSP often blocks data: URLs in <img> / <iframe>; HTTP URLs work.
 */
function quoteAttachmentViewUrl(quote) {
  if (!quote?.id || !quote?.attachment_name) return null;
  const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const path = `/api/quotes/${quote.id}/attachment`;
  const urlParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  const shop = urlParams.get('shop') || '';
  const qs = shop ? `?shop=${encodeURIComponent(shop)}` : '';
  return base ? `${base}${path}${qs}` : `${path}${qs}`;
}

function quoteAttachmentIsImage(quote) {
  const t = (quote?.attachment_type || '').toLowerCase().split(';')[0].trim();
  if (/^image\/(jpe?g|pjpeg|png|gif|webp)$/i.test(t)) return true;
  return /\.(jpe?g|png|gif|webp)$/i.test(quote?.attachment_name || '');
}

function quoteAttachmentIsPdf(quote) {
  const t = (quote?.attachment_type || '').toLowerCase().split(';')[0].trim();
  if (t === 'application/pdf') return true;
  return (quote?.attachment_name || '').toLowerCase().endsWith('.pdf');
}

function quoteModalCustomerLabel(quote) {
  if (!quote) return 'Customer';
  const name = [quote.first_name, quote.last_name].filter(Boolean).join(' ').trim();
  if (name) return name;
  return quote.customer_email || 'Customer';
}

export default function QuotesPage() {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [countryFilter, setCountryFilter] = useState('');
  const [updatingStatus, setUpdatingStatus] = useState(false);

  // Pagination state
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [pagination, setPagination] = useState({ total: 0, totalPages: 1, hasNext: false, hasPrev: false });

  const fetchQuotes = useCallback(() => {
    setLoading(true);
    const params = new URLSearchParams({ page, limit });
    if (countryFilter) params.set('country', countryFilter);

    api.get(`/api/quotes?${params.toString()}`)
      .then(res => {
        setQuotes(res.data?.data || []);
        setPagination(res.data?.pagination || { total: 0, totalPages: 1, hasNext: false, hasPrev: false });
      })
      .catch(() => { setQuotes([]); })
      .finally(() => setLoading(false));
  }, [countryFilter, page, limit]);

  useEffect(() => { fetchQuotes(); }, [fetchQuotes]);

  // Reset to page 1 when filter or limit changes
  useEffect(() => { setPage(1); }, [countryFilter, limit]);

  const openQuote = (quote) => {
    setSelected(quote);
    setModalOpen(true);
  };

  const updateStatus = async (id, status) => {
    setUpdatingStatus(true);
    try {
      await api.patch(`/api/quotes/${id}/status`, { status });
      setQuotes(prev => prev.map(q => q.id === id ? { ...q, status } : q));
      if (selected?.id === id) setSelected(prev => ({ ...prev, status }));
    } catch (e) {
      console.error('Failed to update status');
    } finally {
      setUpdatingStatus(false);
    }
  };

  const formatDate = (dt) => {
    if (!dt) return '—';
    return new Date(dt).toLocaleString('en-IN', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });
  };

  const parseConfigs = (raw) => {
    try { 
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : (raw || []);
      // Check if it's the new format (array of items) or old format (array of configurations)
      if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].product_id) {
        return parsed; // New format: array of product items
      }
      return parsed; // Old format or empty
    }
    catch { return []; }
  };

  // Get total items count from configurations
  const getTotalItems = (quote) => {
    const items = parseConfigs(quote.configurations);
    if (items.length > 0 && items[0].product_id) {
      return items.reduce((sum, item) => sum + (item.quantity || 1), 0);
    }
    return quote.quantity || 1;
  };

  // Get product summary for table display
  const getProductSummary = (quote) => {
    const items = parseConfigs(quote.configurations);
    if (items.length > 0 && items[0].product_id) {
      if (items.length === 1) {
        return items[0].product_title || '—';
      }
      return `${items[0].product_title} + ${items.length - 1} more`;
    }
    return quote.product_title || '—';
  };

  const rows = quotes.map(q => [
    <Button variant="plain" onClick={() => openQuote(q)}>#{q.id}</Button>,
    <Text variant="bodyMd" fontWeight="semibold">
      {q.first_name} {q.last_name}
    </Text>,
    q.customer_email,
    q.country || '—',
    formatDate(q.created_at),
    <InlineStack gap="200">
      <Button size="slim" onClick={() => openQuote(q)}>View</Button>
    </InlineStack>,
  ]);

  // Pagination info text
  const start = pagination.total === 0 ? 0 : (page - 1) * limit + 1;
  const end = Math.min(page * limit, pagination.total);

  return (
    <Page
      title="Quote Requests"
      subtitle="Customer quote requests submitted via the product configurator"
      primaryAction={{ content: 'Refresh', onAction: fetchQuotes }}
    >
      <Layout>
        {/* Filter + Per-page controls */}
        <Layout.Section>
          <Card>
            <InlineStack gap="400" blockAlign="center" wrap>
              <Text variant="bodyMd" fontWeight="semibold">Filter by Country:</Text>
              <Box minWidth="200px">
                <Select
                  options={COUNTRY_OPTIONS}
                  value={countryFilter}
                  onChange={setCountryFilter}
                  label="" labelHidden
                />
              </Box>
              <Box minWidth="150px">
                <Select
                  options={PER_PAGE_OPTIONS}
                  value={String(limit)}
                  onChange={v => setLimit(Number(v))}
                  label="" labelHidden
                />
              </Box>
              <Text variant="bodySm" tone="subdued">
                {pagination.total > 0
                  ? `Showing ${start}–${end} of ${pagination.total} quote${pagination.total !== 1 ? 's' : ''}`
                  : 'No quotes found'}
              </Text>
            </InlineStack>
          </Card>
        </Layout.Section>

        {/* Table */}
        <Layout.Section>
          <Card padding="0">
            {loading ? (
              <Box padding="800">
                <InlineStack align="center"><Spinner size="large" /></InlineStack>
              </Box>
            ) : quotes.length === 0 ? (
              <EmptyState
                heading="No quote requests yet"
                image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
              >
                <p>When customers submit quote requests from your product pages, they'll appear here.</p>
              </EmptyState>
            ) : (
              <DataTable
                columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text']}
                headings={['ID', 'Customer', 'Email', 'Product Used In', 'Submitted', 'VIEW']}
                rows={rows}
                hoverable
              />
            )}
          </Card>
        </Layout.Section>

        {/* Pagination Controls */}
        {!loading && pagination.total > 0 && (
          <Layout.Section>
            <Card>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
                <Text variant="bodySm" tone="subdued">
                  Showing {start}–{end} of {pagination.total} quote{pagination.total !== 1 ? 's' : ''}
                </Text>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <button
                    onClick={() => setPage(p => p - 1)}
                    disabled={!pagination.hasPrev}
                    style={{
                      padding: '6px 14px',
                      border: '1px solid #c9cccf',
                      borderRadius: '6px',
                      background: pagination.hasPrev ? '#fff' : '#f6f6f7',
                      color: pagination.hasPrev ? '#202223' : '#8c9196',
                      cursor: pagination.hasPrev ? 'pointer' : 'not-allowed',
                      fontSize: '13px',
                      fontFamily: 'sans-serif',
                    }}
                  >
                    ← Previous
                  </button>
                  <Text variant="bodySm" tone="subdued">
                    Page {page} of {pagination.totalPages}
                  </Text>
                  <button
                    onClick={() => setPage(p => p + 1)}
                    disabled={!pagination.hasNext}
                    style={{
                      padding: '6px 14px',
                      border: '1px solid #c9cccf',
                      borderRadius: '6px',
                      background: pagination.hasNext ? '#fff' : '#f6f6f7',
                      color: pagination.hasNext ? '#202223' : '#8c9196',
                      cursor: pagination.hasNext ? 'pointer' : 'not-allowed',
                      fontSize: '13px',
                      fontFamily: 'sans-serif',
                    }}
                  >
                    Next →
                  </button>
                </div>
              </div>
            </Card>
          </Layout.Section>
        )}
      </Layout>

      {/* Quote Detail Modal */}
      {selected && (
        <Modal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          title={`Quote #${selected.id} — ${quoteModalCustomerLabel(selected)}`}
          primaryAction={{ content: 'Close', onAction: () => setModalOpen(false) }}
          large
        >
          <Modal.Section>
            <BlockStack gap="400">

              {/* Customer Info */}
              <BlockStack gap="200">
                <Text variant="headingMd" as="h3">Customer Details</Text>
                <InlineStack gap="600" wrap>
                  <BlockStack gap="100">
                    <Text variant="bodySm" tone="subdued">Name</Text>
                    <Text variant="bodyMd" fontWeight="semibold">
                      {selected.first_name} {selected.last_name}
                    </Text>
                  </BlockStack>
                  <BlockStack gap="100">
                    <Text variant="bodySm" tone="subdued">Email</Text>
                    <Text variant="bodyMd">
                      <a href={`mailto:${selected.customer_email}`} style={{ color: '#5c6ac4' }}>
                        {selected.customer_email}
                      </a>
                    </Text>
                  </BlockStack>
                  {selected.customer_phone && (
                    <BlockStack gap="100">
                      <Text variant="bodySm" tone="subdued">Phone</Text>
                      <Text variant="bodyMd">{selected.customer_phone}</Text>
                    </BlockStack>
                  )}
                </InlineStack>
                
                {/* Address Information */}
                {(selected.customer_address || selected.customer_zip || selected.customer_country || selected.country) && (
                  <Box background="bg-surface-secondary" padding="300" borderRadius="200">
                    <BlockStack gap="200">
                      <Text variant="bodySm" tone="subdued">Address</Text>
                      {selected.customer_address && (
                        <Text variant="bodyMd">{selected.customer_address}</Text>
                      )}
                      <InlineStack gap="400" wrap>
                        {selected.customer_zip && (
                          <Text variant="bodyMd">ZIP: {selected.customer_zip}</Text>
                        )}
                        {selected.customer_country && (
                          <Text variant="bodyMd">Country: {selected.customer_country}</Text>
                        )}
                        {selected.country && (
                          <Text variant="bodyMd">Product Used In: {selected.country}</Text>
                        )}
                      </InlineStack>
                    </BlockStack>
                  </Box>
                )}
                
                {selected.project_name && (
                  <BlockStack gap="100">
                    <Text variant="bodySm" tone="subdued">Project Name</Text>
                    <Text variant="bodyMd" fontWeight="semibold">{selected.project_name}</Text>
                  </BlockStack>
                )}
                
                {selected.notes && (
                  <BlockStack gap="100">
                    <Text variant="bodySm" tone="subdued">Notes</Text>
                    <Box background="bg-surface-secondary" padding="300" borderRadius="200">
                      <Text variant="bodyMd">{selected.notes}</Text>
                    </Box>
                  </BlockStack>
                )}
                
                {selected.attachment_name && (() => {
                  const src = quoteAttachmentViewUrl(selected);
                  const showImg = quoteAttachmentIsImage(selected) && src;
                  const showPdf = quoteAttachmentIsPdf(selected) && src;
                  return (
                    <BlockStack gap="200">
                      <Text variant="bodySm" tone="subdued">Attachment</Text>
                      {showImg && (
                        <Box padding="300" background="bg-surface-secondary" borderRadius="200" maxWidth="100%">
                          <img
                            src={src}
                            alt={selected.attachment_name}
                            style={{
                              display: 'block',
                              maxWidth: '100%',
                              maxHeight: '420px',
                              objectFit: 'contain',
                              borderRadius: '8px',
                            }}
                          />
                        </Box>
                      )}
                      {showPdf && (
                        <Box
                          background="bg-surface-secondary"
                          borderRadius="200"
                          overflow="hidden"
                          minHeight="400px"
                        >
                          <iframe
                            title={`PDF: ${selected.attachment_name}`}
                            src={src}
                            style={{
                              width: '100%',
                              height: '420px',
                              border: 'none',
                              display: 'block',
                            }}
                          />
                        </Box>
                      )}
                      {src ? (
                        <Text variant="bodyMd">
                          <a
                            href={src}
                            download={selected.attachment_name}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#5c6ac4', wordBreak: 'break-all' }}
                          >
                            Download {selected.attachment_name}
                          </a>
                        </Text>
                      ) : (
                        <Text variant="bodyMd">📎 {selected.attachment_name}</Text>
                      )}
                    </BlockStack>
                  );
                })()}
                
                {selected.customer_message && (
                  <BlockStack gap="100">
                    <Text variant="bodySm" tone="subdued">Message</Text>
                    <Box background="bg-surface-secondary" padding="300" borderRadius="200">
                      <Text variant="bodyMd">{selected.customer_message}</Text>
                    </Box>
                  </BlockStack>
                )}
              </BlockStack>

              <Divider />

              {/* Products Info - Updated for RFQ Cart */}
              <BlockStack gap="200">
                <Text variant="headingMd" as="h3">Products</Text>
                {(() => {
                  const items = parseConfigs(selected.configurations);
                  if (items.length > 0 && items[0].product_id) {
                    // New format: multiple products
                    return (
                      <BlockStack gap="300">
                        {items.map((item, idx) => (
                          <Box key={idx} background="bg-surface-secondary" padding="300" borderRadius="200">
                            <BlockStack gap="200">
                              <InlineStack align="space-between">
                                <Text variant="bodyMd" fontWeight="semibold">Item #{idx + 1}</Text>
                                <Text variant="bodySm" tone="subdued">Qty: {item.quantity || 1}</Text>
                              </InlineStack>
                              
                              {item.product_image && (
                                <Box>
                                  <img 
                                    src={item.product_image} 
                                    alt={item.product_title || 'Product'} 
                                    style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '8px' }}
                                  />
                                </Box>
                              )}
                              
                              <BlockStack gap="100">
                                <Text variant="bodyMd" fontWeight="semibold">{item.product_title || '—'}</Text>
                                {(() => {
                                  // Clean SKU - remove price and stock status
                                  let cleanSku = (item.sku || '').trim();
                                  cleanSku = cleanSku
                                    .replace(/\s*-\s*\$[\d.,]+\s*-\s*(Sold out|In stock)/i, '')
                                    .replace(/\s*-\s*\$[\d.,]+/i, '')
                                    .replace(/\s*-\s*(Sold out|In stock)/i, '')
                                    .replace(/Default Title/i, '')
                                    .trim();
                                  // Remove "SKU: " prefix if it exists
                                  cleanSku = cleanSku.replace(/^SKU:\s*/i, '');
                                  return cleanSku ? (
                                    <Text variant="bodySm" tone="subdued">SKU: {cleanSku}</Text>
                                  ) : null;
                                })()}
                              </BlockStack>
                              
                              {item.variant_title && 
                               item.variant_title !== 'Default Title' && 
                               !item.variant_title.includes('$') && 
                               !item.variant_title.toLowerCase().includes('sold out') &&
                               !item.variant_title.toLowerCase().includes('in stock') && (
                                <BlockStack gap="100">
                                  <Text variant="bodySm" tone="subdued">Variant</Text>
                                  <Text variant="bodyMd">{item.variant_title}</Text>
                                </BlockStack>
                              )}
                              
                              {item.variant_options && item.variant_options.length > 0 && (
                                <BlockStack gap="100">
                                  <Text variant="bodySm" tone="subdued">Variant Options</Text>
                                  <Box>
                                    {item.variant_options.map((opt, i) => (
                                      <Text key={i} variant="bodySm">• {opt.label}: {opt.value}</Text>
                                    ))}
                                  </Box>
                                </BlockStack>
                              )}
                              
                              {item.configurations && item.configurations.length > 0 && (
                                <BlockStack gap="100">
                                  <Text variant="bodySm" tone="subdued">Custom Options</Text>
                                  <Box>
                                    {item.configurations.map((cfg, i) => (
                                      <Text key={i} variant="bodySm">• {cfg.label}: {cfg.value || '—'}</Text>
                                    ))}
                                  </Box>
                                </BlockStack>
                              )}
                              
                              {item.product_url && (
                                <Button
                                  variant="plain"
                                  size="slim"
                                  onClick={() => openStorefrontProductUrl(item.product_url)}
                                  accessibilityLabel="View product on storefront (opens in new tab)"
                                >
                                  View Product →
                                </Button>
                              )}
                            </BlockStack>
                          </Box>
                        ))}
                      </BlockStack>
                    );
                  } else {
                    // Old format: single product
                    return (
                      <>
                        <InlineStack gap="600" wrap>
                          <BlockStack gap="100">
                            <Text variant="bodySm" tone="subdued">Product</Text>
                            <Text variant="bodyMd" fontWeight="semibold">{selected.product_title || '—'}</Text>
                          </BlockStack>
                          {selected.variant_title && selected.variant_title !== 'Default Title' && (
                            <BlockStack gap="100">
                              <Text variant="bodySm" tone="subdued">Variant</Text>
                              <Text variant="bodyMd">{selected.variant_title}</Text>
                            </BlockStack>
                          )}
                          <BlockStack gap="100">
                            <Text variant="bodySm" tone="subdued">Quantity</Text>
                            <Text variant="bodyMd">{selected.quantity || 1}</Text>
                          </BlockStack>
                        </InlineStack>
                        {selected.product_url && (
                          <Button
                            variant="plain"
                            onClick={() => openStorefrontProductUrl(selected.product_url)}
                            accessibilityLabel="View product on storefront (opens in new tab)"
                          >
                            View Product →
                          </Button>
                        )}
                        
                        {/* Old format configurations */}
                        {items.length > 0 && (
                          <>
                            <Divider />
                            <Text variant="headingMd" as="h3">Selected Options</Text>
                            <Box
                              background="bg-surface-secondary"
                              borderRadius="200"
                              padding="0"
                              borderWidth="025"
                              borderColor="border"
                            >
                              {items.map((cfg, i, arr) => (
                                <Box
                                  key={i}
                                  padding="300"
                                  borderBlockEndWidth={i < arr.length - 1 ? '025' : '0'}
                                  borderColor="border"
                                >
                                  <InlineStack align="space-between">
                                    <Text variant="bodyMd" fontWeight="semibold" tone="subdued">{cfg.label}</Text>
                                    <Text variant="bodyMd">{cfg.value || '—'}</Text>
                                  </InlineStack>
                                </Box>
                              ))}
                            </Box>
                          </>
                        )}
                      </>
                    );
                  }
                })()}
              </BlockStack>

              <Divider />
              <Text variant="bodySm" tone="subdued">Submitted: {formatDate(selected.created_at)}</Text>
            </BlockStack>
          </Modal.Section>
        </Modal>
      )}
    </Page>
  );
}
